import { render } from "./ReporteVentas.vue?vue&type=template&id=242f21bd"
import script from "./ReporteVentas.vue?vue&type=script&lang=js"
export * from "./ReporteVentas.vue?vue&type=script&lang=js"

import "./ReporteVentas.vue?vue&type=style&index=0&id=242f21bd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__